<div
  class="aca-page-state__container"
  [class.aca-page-state--loading]="state() === 'loading'"
  [class.aca-page-state--empty]="state() === 'empty'"
  [class.aca-page-state--error]="state() === 'error'"
  [class.aca-page-state--unauthorized]="state() === 'unauthorized'"
  [class.aca-page-state--not-found]="state() === 'not-found'"
  [attr.role]="resolvedRole()"
  [attr.aria-live]="state() === 'error' || state() === 'unauthorized' ? 'assertive' : 'polite'"
>
  @switch (state()) {
    @case ('loading') {
      <mat-spinner class="aca-page-state__spinner" diameter="40" mode="indeterminate" />
      @if (title()) {
        <h3 class="aca-page-state__title">{{ title() | translate }}</h3>
      }
    }
    @default {
      <mat-icon class="aca-page-state__icon">{{ resolvedIcon() }}</mat-icon>
      @if (title()) {
        <h3 class="aca-page-state__title">{{ title() | translate }}</h3>
      }
      @if (message()) {
        <p class="aca-page-state__message">{{ message() | translate }}</p>
      }
      @if (actionLabel()) {
        <button mat-stroked-button class="aca-page-state__action" (click)="onAction()" type="button">
          {{ actionLabel() | translate }}
        </button>
      }
    }
  }
</div>
